import { v4 as uuid } from "uuid";

import {
  shoe1,
  shoe2,
  shoe3,
  shoe4,
  shoe5,
  shoe6,
  shoe7,
  shoe8,
  jacket1,
  jacket2,
  jacket3,
  jacket4,
  jacket5,
  jacket6,
  jacket7,
  jacket8,
  accessory1,
  accessory2,
  accessory3,
  accessory4,
  accessory5,
  accessory6,
  accessory7,
  accessory8,
} from "../../assets";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: shoe1,
    subtitle: "Soft Trainers",
    brand: "Zara",
    discountedPrice: "3590",
    originalPrice: "5999",
    categoryName: "shoes",
    gender: "men",
    rating: 4.1,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: shoe2,
    subtitle: "Running Trainers",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "7999",
    categoryName: "shoes",
    gender: "men",
    rating: 4.2,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: shoe3,
    subtitle: "Multi-Piece Trainers",
    brand: "Westside",
    discountedPrice: "3590",
    originalPrice: "4999",
    categoryName: "shoes",
    gender: "men",
    rating: 3.7,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: shoe4,
    subtitle: "MultiColored Running",
    brand: "H&M",
    discountedPrice: "4590",
    originalPrice: "6599",
    categoryName: "shoes",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: shoe5,
    subtitle: "Retro Monochrome Trainer",
    brand: "H&M",
    discountedPrice: "2990",
    originalPrice: "3999",
    categoryName: "shoes",
    gender: "men",
    rating: 3.1,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: shoe6,
    subtitle: "Contrast Running Trainer",
    brand: "Westside",
    discountedPrice: "1990",
    originalPrice: "2599",
    categoryName: "shoes",
    gender: "men",
    rating: 4.5,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: shoe7,
    subtitle: "Multipiece Sneaker",
    brand: "Zara",
    discountedPrice: "3990",
    originalPrice: "5999",
    categoryName: "shoes",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: shoe8,
    subtitle: "Running Trainers With Zip",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "8999",
    categoryName: "shoes",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: jacket1,
    subtitle: "Hooded Jacket",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "9999",
    categoryName: "jackets",
    gender: "men",
    rating: 4.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: jacket2,
    subtitle: "Jacquard Jacket",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "7999",
    categoryName: "jackets",
    gender: "men",
    rating: 4.1,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: jacket3,
    subtitle: "Contrast Patch Jacket",
    brand: "Westside",
    discountedPrice: "3560",
    originalPrice: "5999",
    categoryName: "jackets",
    gender: "men",
    rating: 3.7,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: jacket4,
    subtitle: "Boat Print Jacket",
    brand: "H&M",
    discountedPrice: "4590",
    originalPrice: "4999",
    categoryName: "jackets",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: jacket5,
    subtitle: "Bandanna Print Jacket",
    brand: "H&M",
    discountedPrice: "2990",
    originalPrice: "3599",
    categoryName: "jackets",
    gender: "men",
    rating: 3.3,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: jacket6,
    subtitle: "Faux Leather Jacket",
    brand: "Westside",
    discountedPrice: "6990",
    originalPrice: "8999",
    categoryName: "jackets",
    gender: "men",
    rating: 4.6,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },

  {
    _id: uuid(),
    title: "Zara",
    imgSrc: jacket7,
    subtitle: "Metallic Puffer Jacket",
    brand: "Zara",
    discountedPrice: "3990",
    originalPrice: "5999",
    categoryName: "jackets",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: jacket8,
    subtitle: "Linen Jacket",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "9999",
    categoryName: "jackets",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: accessory1,
    subtitle: "Man Gold + Man Silver Perfume",
    brand: "Zara",
    discountedPrice: "3590",
    originalPrice: "5999",
    categoryName: "accessories",
    gender: "men",
    rating: 4.8,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: accessory2,
    subtitle: "Man Gold Perfume",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "7599",
    categoryName: "accessories",
    gender: "men",
    rating: 4.4,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: accessory3,
    subtitle: "Tie with insects",
    brand: "Westside",
    discountedPrice: "590",
    originalPrice: "799",
    categoryName: "accessories",
    gender: "men",
    rating: 3.7,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: accessory4,
    subtitle: "Tie with dogs",
    brand: "H&M",
    discountedPrice: "590",
    originalPrice: "699",
    categoryName: "accessories",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "H&M",
    imgSrc: accessory5,
    subtitle: "Shearling Belt Bag",
    brand: "H&M",
    discountedPrice: "2990",
    originalPrice: "3599",
    categoryName: "accessories",
    gender: "men",
    rating: 3.0,
    qty: 1,
    productDescription: "H&M Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Westside",
    imgSrc: accessory6,
    subtitle: "Flat Cap",
    brand: "Westside",
    discountedPrice: "1990",
    originalPrice: "2599",
    categoryName: "accessories",
    gender: "men",
    rating: 4.3,
    qty: 1,
    productDescription: "Westside Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: accessory7,
    subtitle: "Bucket Hat",
    brand: "Zara",
    discountedPrice: "3990",
    originalPrice: "4599",
    categoryName: "accessories",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
  {
    _id: uuid(),
    title: "Zara",
    imgSrc: accessory8,
    subtitle: "Slogan Cap",
    brand: "Zara",
    discountedPrice: "5990",
    originalPrice: "8599",
    categoryName: "accessories",
    gender: "men",
    rating: 5.0,
    qty: 1,
    productDescription: "Zara Retail Private Limited",
  },
];
